import React from 'react';
import styled from 'styled-components';

const Star = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        fill="#263340"
        d="M15.44 5.914c-.14-.375-.501-.625-.905-.626h-3.919c-.137 0-.258-.085-.304-.213L8.905 1.122C8.72.627 8.162.376 7.663.561c-.262.097-.469.302-.567.561l-.003.01L5.69 5.076c-.046.128-.167.213-.304.213h-3.92c-.533 0-.966.428-.966.957 0 .284.127.553.346.735l3.338 2.745c.102.084.142.221.1.346L2.88 14.24c-.168.502.105 1.044.611 1.211.297.099.624.048.877-.136l3.441-2.502c.114-.082.268-.082.38 0l3.441 2.502c.43.313 1.034.222 1.35-.204.187-.25.238-.575.139-.87l-1.402-4.171c-.042-.125-.003-.263.1-.347l3.343-2.748c.308-.26.42-.684.279-1.06z"
      />
    </svg>
  );
};
export default styled(Star)`
  path {
    fill: var(--grey300);
  }
`;
